const investmentTypeOptions = [
  { value: 'CRYPTOCURRENCY', text: 'Cryptocurrency' },
  { value: 'FIXED_DEPOSIT', text: 'Fixed deposit' },
  { value: 'FUNERAL_POLICY', text: 'Funeral Policy' },
  { value: 'LIFE_INSURANCE', text: 'Life Insurance' },
  { value: 'PENSION_FUND', text: 'Pension Fund' },
  { value: 'RETIREMENT_ANNUITY', text: 'Retirement Annuity' },
  { value: 'SHARES', text: 'Shares' },
  { value: 'SHAREHOLDING_IN_A_BUSINESS', text: 'Shareholding in a business' },
  { value: 'SAVINGS', text: 'Savings' },
  { value: 'TAX_EXEMPT_INVESTMENT', text: 'Tax exempt investment' },
  { value: 'OTHER', text: 'Other' },
];

function financialAssetType(financialAsset) {
  if (financialAsset.investmentType == 'OTHER') {
    return financialAsset.otherInvestmentType;
  } else {
    const investmentType = investmentTypeOptions.find(
      i => i.value == financialAsset.investmentType
    );
    return investmentType.text;
  }
}

export { investmentTypeOptions, financialAssetType };
